// frontend/src/App.js
import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate, NavLink } from 'react-router-dom';
import axios from 'axios';

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000' : '';

const ModernStyles = () => (
  <style>{`
    * { box-sizing: border-box; }
    body { margin: 0; font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; background-color: #f8fafc; color: #334155; }
    .navbar { background: #ffffff; box-shadow: 0 1px 3px rgba(0,0,0,0.05); padding: 0 24px; height: 64px; display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0; z-index: 100; border-bottom: 1px solid #e2e8f0; }
    .nav-links { display: flex; gap: 8px; }
    .nav-item { text-decoration: none; color: #64748b; padding: 8px 16px; border-radius: 8px; font-weight: 600; font-size: 14px; transition: all 0.2s; }
    .nav-item:hover { background: #f1f5f9; color: #0f172a; }
    .nav-item.active { background: #e0e7ff; color: #4338ca; }
    .main-container { max-width: 1280px; margin: 32px auto; padding: 0 24px; }
    .card { background: #ffffff; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03); padding: 24px; margin-bottom: 24px; border: 1px solid #e2e8f0; transition: box-shadow 0.2s; }
    .card:hover { box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05), 0 4px 6px -2px rgba(0,0,0,0.025); }
    .card-title { font-size: 18px; font-weight: 600; margin-top: 0; margin-bottom: 20px; color: #0f172a; display: flex; align-items: center; gap: 8px;}
    .form-label { display: block; font-size: 14px; font-weight: 600; margin-bottom: 8px; color: #475569; }
    .form-control { width: 100%; padding: 10px 14px; font-size: 14px; border: 1px solid #cbd5e1; border-radius: 8px; transition: all 0.2s; font-family: inherit; background: #fff; color: #1e293b; }
    .form-control:focus { outline: none; border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,0.15); }
    .form-control::placeholder { color: #94a3b8; }
    .btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 18px; font-size: 14px; font-weight: 600; border-radius: 8px; border: none; cursor: pointer; transition: all 0.2s; white-space: nowrap; }
    .btn-sm { padding: 6px 12px; font-size: 13px; border-radius: 6px; }
    .btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none !important; box-shadow: none !important; }
    .btn-primary { background: #4f46e5; color: white; }
    .btn-primary:hover:not(:disabled) { background: #4338ca; transform: translateY(-1px); box-shadow: 0 4px 6px -1px rgba(79,70,229,0.2); }
    .btn-success { background: #10b981; color: white; }
    .btn-success:hover:not(:disabled) { background: #059669; transform: translateY(-1px); box-shadow: 0 4px 6px -1px rgba(16,185,129,0.2); }
    .btn-danger { background: #ef4444; color: white; }
    .btn-danger:hover:not(:disabled) { background: #dc2626; transform: translateY(-1px); box-shadow: 0 4px 6px -1px rgba(239,68,68,0.2); }
    .btn-warning { background: #f59e0b; color: white; }
    .btn-warning:hover:not(:disabled) { background: #d97706; transform: translateY(-1px); box-shadow: 0 4px 6px -1px rgba(245,158,11,0.2); }
    .btn-secondary { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; }
    .btn-secondary:hover:not(:disabled) { background: #e2e8f0; color: #0f172a; }
    .table-wrapper { overflow-x: auto; background: white; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); border: 1px solid #e2e8f0; }
    .modern-table { width: 100%; border-collapse: collapse; text-align: left; }
    .modern-table th { background: #f8fafc; padding: 14px 20px; font-weight: 600; color: #64748b; font-size: 13px; text-transform: uppercase; letter-spacing: 0.05em; border-bottom: 1px solid #e2e8f0; white-space: nowrap; }
    .modern-table td { padding: 14px 20px; border-bottom: 1px solid #f1f5f9; font-size: 14px; color: #334155; }
    .modern-table tr:last-child td { border-bottom: none; }
    .modern-table tbody tr:hover { background-color: #f8fafc; }
    .badge { display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 9999px; font-size: 12px; font-weight: 600; white-space: nowrap; }
    .badge-success { background: #d1fae5; color: #065f46; }
    .badge-warning { background: #fef3c7; color: #92400e; }
    .badge-danger { background: #fee2e2; color: #991b1b; }
    .badge-info { background: #e0e7ff; color: #3730a3; }
    .badge-neutral { background: #f1f5f9; color: #475569; }
    .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(15, 23, 42, 0.5); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 2000; padding: 20px; }
    .modal-content { background: white; border-radius: 16px; padding: 32px; width: 100%; max-width: 550px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04); max-height: 90vh; overflow-y: auto; }
    .flex { display: flex; }
    .items-center { align-items: center; }
    .justify-between { justify-content: space-between; }
    .gap-2 { gap: 8px; }
    .gap-3 { gap: 12px; }
    .gap-4 { gap: 16px; }
    .text-center { text-align: center; }
  `}</style>
);

function Login({ onLogin }) {
  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const navigate = useNavigate();
  
  const handleLogin = async () => {
    try {
      const res = await axios.post('/login', { username: user, password: pwd });
      if (res.data.status === 'ok') {
        localStorage.setItem('sysUser', res.data.username);
        onLogin(res.data.username);
        navigate('/search');
      } else alert(res.data.msg);
    } catch (e) { alert("网络错误"); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%)' }}>
      <ModernStyles />
      <div className="card" style={{ width: '100%', maxWidth: '420px', padding: '40px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
        <div className="text-center" style={{ marginBottom: '32px' }}>
          <div style={{ width: '60px', height: '60px', background: 'linear-gradient(135deg, #6366f1, #4f46e5)', borderRadius: '16px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', boxShadow: '0 10px 15px -3px rgba(99,102,241,0.3)' }}>
            <span style={{ fontSize: '28px', color: 'white' }}>🚀</span>
          </div>
          <h2 style={{ color: '#0f172a', fontSize: '26px', margin: '0 0 8px 0', fontWeight: 'bold' }}>微媒采集系统</h2>
          <p style={{ color: '#64748b', fontSize: '14px', margin: 0 }}>专业独立站自动化采集与分发引擎</p>
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label className="form-label">管理员账号</label>
          <input className="form-control" placeholder="输入账号 (如: 001)" value={user} onChange={e => setUser(e.target.value)} />
        </div>
        <div style={{ marginBottom: '32px' }}>
          <label className="form-label">访问密码</label>
          <input className="form-control" type="password" placeholder="输入安全密码" value={pwd} onChange={e => setPwd(e.target.value)} />
        </div>
        <button className="btn btn-primary" style={{ width: '100%', padding: '12px', fontSize: '16px' }} onClick={handleLogin}>
          安全登录
        </button>
      </div>
    </div>
  );
}

// 页面 1：找站采集
function UrlSearch({ currentUser, globalProxy }) {
  const [keyword, setKeyword] = useState('');
  const [limit, setLimit] = useState(1000);
  const [apiKey, setApiKey] = useState(localStorage.getItem('serperApiKey') || '');
  const [taskId, setTaskId] = useState(localStorage.getItem('currentSerperTaskId') || null);
  
  const [statusData, setStatusData] = useState({ is_running: false, results: [], success_count: 0, duplicate_count: 0, error_msg: '' });
  const [errorModalMsg, setErrorModalMsg] = useState(null);

  useEffect(() => {
    let timer;
    if (taskId) {
      timer = setInterval(async () => {
        const res = await axios.get(`/status_url/${taskId}`);
        if (res.data && !res.data.error) {
          setStatusData(res.data);
          if (res.data.is_running === false) clearInterval(timer);
        }
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [taskId]);

  const start = async () => {
    if (!apiKey) return alert("请输入 Serper API 密钥！");
    if (!keyword) return alert("请输入搜索关键词！");
    localStorage.setItem('serperApiKey', apiKey);
    
    setStatusData({ is_running: true, results: [], success_count: 0, duplicate_count: 0, error_msg: '' });
    
    const res = await axios.post('/start_url', { keyword, limit: parseInt(limit), api_key: apiKey, username: currentUser, proxy: globalProxy });
    if(res.data.task_id) {
      setTaskId(res.data.task_id);
      localStorage.setItem('currentSerperTaskId', res.data.task_id);
    }
  };

  return (
    <div>
      {errorModalMsg !== null && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{ marginTop: 0, color: '#e3242b', borderBottom: '1px solid #f1f5f9', paddingBottom: '15px' }}>⚠️ 系统异常拦截</h3>
            <textarea readOnly value={errorModalMsg || '无详细错误信息'} style={{ width: '100%', height: '180px', padding: '12px', border: '1px solid #e2e8f0', background: '#f8fafc', borderRadius: '8px', fontFamily: 'monospace', fontSize: '13px', resize: 'none', color: '#334155', marginTop: '10px' }} />
            <div className="flex justify-between items-center" style={{ marginTop: '24px' }}>
              <span style={{ fontSize: '12px', color: '#94a3b8' }}>请联系系统管理员排查</span>
              <button className="btn btn-secondary" onClick={() => setErrorModalMsg(null)}>关闭窗口</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <h3 className="card-title">🔍 配置搜索采集源</h3>
        <div className="flex gap-4" style={{ marginBottom: '20px', alignItems: 'center' }}>
          <label className="form-label" style={{ margin: 0, width: '100px' }}>API 密钥</label>
          <input type="password" value={apiKey} onChange={e => setApiKey(e.target.value)} placeholder="输入 Serper 开发者密钥" className="form-control" style={{ maxWidth: '400px' }} />
        </div>
        
        <div className="flex gap-4" style={{ alignItems: 'flex-start' }}>
          <label className="form-label" style={{ margin: 0, width: '100px', paddingTop: '10px' }}>批量搜索词</label>
          <textarea 
            value={keyword} onChange={e => setKeyword(e.target.value)} 
            placeholder="支持批量，一行一个，例如:&#10;shoes&#10;dress&#10;" 
            className="form-control" style={{ maxWidth: '400px', minHeight: '138px' }} 
          />
          <div style={{ padding: '16px', background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '8px', minWidth: '240px' }}>
            <label className="form-label" style={{ marginBottom: '10px' }}>单词最大抓取量</label>
            <input type="number" value={limit} onChange={e => setLimit(e.target.value)} className="form-control" style={{ marginBottom: '16px' }} />
            <button onClick={start} disabled={statusData.is_running} className="btn btn-primary" style={{ width: '100%' }}>
              {statusData.is_running ? '🚀 后台静默采集中...' : '▶️ 开始后台挂机执行'}
            </button>
          </div>
        </div>
      </div>
      
      <div className="card flex items-center justify-between" style={{ background: 'linear-gradient(to right, #f8fafc, #f1f5f9)' }}>
        <div className="flex items-center gap-3">
          <span style={{ fontWeight: 600, color: '#475569' }}>采集引擎状态:</span>
          {statusData.is_running ? <span className="badge badge-warning">🔄 运行中</span> : (taskId ? (statusData.error_msg ? <span className="badge badge-danger">⚠️ 异常停止</span> : <span className="badge badge-success">✅ 任务结束</span>) : <span className="badge badge-neutral">💤 待机</span>)}
          
          {statusData.error_msg && !statusData.is_running && (
            <button onClick={() => setErrorModalMsg(statusData.error_msg)} className="btn btn-danger btn-sm">
              查看报错原因
            </button>
          )}
        </div>
        <div className="flex items-center gap-4">
          <div style={{ background: 'white', padding: '10px 20px', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>本次成功入库</span>
            <b style={{ color: '#10b981', fontSize: '24px' }}>{statusData.success_count}</b>
          </div>
          <div style={{ background: 'white', padding: '10px 20px', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <span style={{ fontSize: '12px', color: '#64748b', fontWeight: 600 }}>拦截全局重复</span>
            <b style={{ color: '#ef4444', fontSize: '24px' }}>{statusData.duplicate_count}</b>
          </div>
        </div>
      </div>
    </div>
  );
}

// 页面 2：全局网址库看板
function GlobalDashboard({ currentUser }) {
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({ url: '', cms: '', keyword: '', username: currentUser, is_added: '' });
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const pageSize = 50; 

  const [selectedUrls, setSelectedUrls] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [pendingUrls, setPendingUrls] = useState([]);
  const [duplicateUrls, setDuplicateUrls] = useState([]);

  const fetchData = async (pageToFetch = currentPage) => {
    const params = Object.fromEntries(Object.entries(filters).filter(([_, v]) => v !== ''));
    params.page = pageToFetch;
    params.page_size = pageSize;
    
    try {
      const res = await axios.get('/data_url', { params });
      setData(res.data.data);
      setTotalItems(res.data.total);
      setSelectedUrls([]);
    } catch (e) { console.error("抓取全局库失败:", e); }
  };

  useEffect(() => { 
    fetchData(currentPage); 
  }, [currentPage]);

  const handleSearch = () => {
    if (currentPage === 1) fetchData(1);
    else setCurrentPage(1); 
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) setSelectedUrls(data.map(d => d.url));
    else setSelectedUrls([]);
  };
  const handleSelect = (url) => {
    if (selectedUrls.includes(url)) setSelectedUrls(selectedUrls.filter(u => u !== url));
    else setSelectedUrls([...selectedUrls, url]);
  };
  const deleteUrls = async (urls) => {
    if(!window.confirm(`确定要删除 ${urls.length} 条记录吗？`)) return;
    await axios.post('/delete_urls', { urls });
    fetchData(currentPage);
  };
  const openUrls = () => {
    if (selectedUrls.length === 0) return alert("请先勾选网站");
    selectedUrls.forEach(url => window.open(url, '_blank'));
  };

  const checkAndAdd = async (urls) => {
    if(urls.length === 0) return;
    const res = await axios.post('/check_shopify_duplicates', { domains: urls });
    const duplicates = res.data.duplicates;
    if (duplicates.length > 0) {
      setPendingUrls(urls);
      setDuplicateUrls(duplicates);
      setShowModal(true);
    } else {
      confirmExecuteAdd(urls);
    }
  };

  const confirmExecuteAdd = async (urlsToJoin) => {
    if (urlsToJoin.length === 0) { alert("去重后没有可加入的网址！"); return; }
    await axios.post('/add_shopify_tasks', { domains: urlsToJoin, username: currentUser });
    alert(`成功将 ${urlsToJoin.length} 个网站加入待采集队列！\n请前往【3. Shopify API 导入】查看`);
    setSelectedUrls([]);
    setShowModal(false);
    fetchData(currentPage); 
  };

  const renderCmsIcon = (cms) => {
    if (cms === 'Shopify') {
      return (
        <div title="Shopify 建站平台" style={{ display: 'flex', justifyContent: 'center' }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.46 29.08" width="22" height="22">
             <path fill="#95BF47" d="M22.56,8.23c-.19-.53-.47-.76-.75-.84l-5.6-1.78c-.33-.11-.69-.06-1,.09l-5.32,2.83L4.54,6.34c-.33-.1-.68-.06-.99.1L.17,8.21c-.28.13-.51.39-.62.9-.12.56-.09 1.3.1 2.1l3.92,13.73c.17.6.72 1.03 1.34 1.03h16.03c.62 0 1.16-.43 1.34-1.03l3.9-13.71c.2-.87.23-1.66.1-2.27a3.8 3.8 0 0 0-.38-1.35z"/>
             <path fill="#ffffff" d="M14.54 19.38c-.89.49-1.99.77-3.2.77-2.83 0-5.29-1.63-5.29-4.66 0-2.84 2.16-4.63 5.33-4.63 1.28 0 2.47.32 3.38.83l-.55 1.82c-.76-.43-1.72-.69-2.76-.69-1.92 0-3.36 1.08-3.36 2.72 0 1.59 1.35 2.7 3.21 2.7.96 0 1.84-.22 2.51-.59l.73 1.73z"/>
          </svg>
        </div>
      );
    }
    return <span className="badge badge-neutral">{cms}</span>;
  };

  return (
    <div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{ marginTop: 0, color: '#e3242b', borderBottom: '1px solid #f1f5f9', paddingBottom: '15px' }}>⚠️ 发现重复任务域名</h3>
            <p style={{ color: '#475569', fontSize: '14px' }}>您选中的网址中，有 <b style={{ color: '#ef4444', fontSize: '16px' }}>{duplicateUrls.length}</b> 个已经存在于团队的采集任务库中：</p>
            <ul style={{ maxHeight: '200px', overflowY: 'auto', background: '#f8fafc', padding: '15px 20px 15px 35px', borderRadius: '8px', border: '1px solid #e2e8f0', color: '#334155' }}>
              {duplicateUrls.map((u, i) => <li key={i} style={{ marginBottom: '6px', fontSize: '13px' }}>{u}</li>)}
            </ul>
            <div className="flex justify-between items-center" style={{ marginTop: '24px' }}>
              <button onClick={() => setShowModal(false)} className="btn btn-secondary">取消操作</button>
              <div className="flex gap-3">
                <button onClick={() => confirmExecuteAdd(pendingUrls.filter(u => !duplicateUrls.includes(u)))} className="btn btn-primary">智能去重后加入</button>
                <button onClick={() => confirmExecuteAdd(pendingUrls)} className="btn btn-danger">无视警告强制加入</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <h3 className="card-title">🗄️ 全局数据检索中心</h3>
        <div className="flex gap-3 items-center" style={{ flexWrap: 'wrap' }}>
          <input placeholder="搜索独立站网址..." className="form-control" onChange={e => setFilters({...filters, url: e.target.value})} style={{ width: '220px' }} />
          <input placeholder="搜索建站平台..." className="form-control" onChange={e => setFilters({...filters, cms: e.target.value})} style={{ width: '150px' }} />
          <input placeholder="搜索关键词..." className="form-control" onChange={e => setFilters({...filters, keyword: e.target.value})} style={{ width: '150px' }} />
          <input placeholder="采集负责人" className="form-control" value={filters.username} onChange={e => setFilters({...filters, username: e.target.value})} style={{ width: '120px' }} />
          <select className="form-control" onChange={e => setFilters({...filters, is_added: e.target.value})} style={{ width: '160px' }}>
            <option value="">全部加入状态</option>
            <option value="1">✅ 已加入队列</option>
            <option value="0">⏳ 待加入队列</option>
          </select>
          <button onClick={handleSearch} className="btn btn-primary">🔍 查询全局库</button>
        </div>
      </div>

      <div className="flex gap-3 mb-4">
        <button onClick={() => checkAndAdd(selectedUrls)} disabled={selectedUrls.length === 0} className="btn btn-success">➕ 批量加入采集任务</button>
        <button onClick={openUrls} disabled={selectedUrls.length === 0} className="btn btn-warning">🌐 一键打开选中网站</button>
        <button onClick={() => deleteUrls(selectedUrls)} disabled={selectedUrls.length === 0} className="btn btn-danger">🗑️ 批量永久删除</button>
      </div>
      
      <div className="table-wrapper">
        <table className="modern-table">
          <thead>
            <tr>
              <th style={{ width: '40px', textAlign: 'center' }}><input type="checkbox" onChange={handleSelectAll} checked={selectedUrls.length === data.length && data.length > 0} style={{ cursor: 'pointer' }} /></th>
              <th style={{ width: '80px' }}>操作人</th>
              <th style={{ width: '80px', textAlign: 'center' }}>平台</th>
              {/* 🌟 修改点 1：将单一的网址列变为聚合展示列 */}
              <th>独立站信息 (标题 / 网址 / 简介)</th>
              <th style={{ width: '160px' }}>搜索词来源</th>
              <th style={{ textAlign: 'center', width: '100px' }}>加入状态</th>
              <th style={{ width: '140px', textAlign: 'center' }}>操作</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr key={i}>
                <td style={{ textAlign: 'center' }}><input type="checkbox" checked={selectedUrls.includes(item.url)} onChange={() => handleSelect(item.url)} style={{ cursor: 'pointer' }} /></td>
                <td style={{ fontWeight: 600 }}>{item.username}</td>
                <td style={{ textAlign: 'center' }}>{renderCmsIcon(item.cms)}</td>
                
                {/* 🌟 修改点 2：聚合展示 Title, URL, Snippet */}
                <td>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxWidth: '400px' }}>
                    <div style={{ fontWeight: 600, color: '#0f172a', fontSize: '15px' }} title={item.title}>{item.title || '未知标题'}</div>
                    <a href={item.url} target="_blank" rel="noreferrer" style={{ color: '#4f46e5', textDecoration: 'none', fontSize: '13px', fontWeight: 500 }}>{item.url}</a>
                    <div style={{ color: '#64748b', fontSize: '13px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.5' }} title={item.snippet}>
                      {item.snippet || '暂无简介数据'}
                    </div>
                  </div>
                </td>

                <td style={{ color: '#64748b', fontSize: '13px' }}>{item.keyword.replace(/site:myshopify\.com/gi, '').trim()}</td>
                <td style={{ textAlign: 'center' }}>
                  {item.is_added === "1" ? <span className="badge badge-success">已加入</span> : <span className="badge badge-warning">待加入</span>}
                </td>
                <td style={{ textAlign: 'center' }}>
                  <div className="flex justify-center gap-2">
                    <button onClick={() => checkAndAdd([item.url])} disabled={item.is_added === "1"} className="btn btn-primary btn-sm" style={{ opacity: item.is_added === "1" ? 0.5 : 1 }}>
                      {item.is_added === "1" ? '已推送' : '去采集'}
                    </button>
                    <button onClick={() => deleteUrls([item.url])} className="btn btn-danger btn-sm">删除</button>
                  </div>
                </td>
              </tr>
            ))}
            {data.length === 0 && <tr><td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>暂无数据</td></tr>}
          </tbody>
        </table>
      </div>

      {totalItems > 0 && (
        <div className="flex justify-between items-center" style={{ marginTop: '20px', background: 'white', padding: '12px 24px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <span style={{ fontSize: '14px', color: '#64748b' }}>
            共 <b style={{ color: '#0f172a', fontSize: '16px' }}>{totalItems}</b> 条网址记录，当前第 <b style={{ color: '#4f46e5', fontSize: '16px' }}>{currentPage}</b> / {Math.ceil(totalItems / pageSize)} 页
          </span>
          <div className="flex gap-2">
            <button 
              className="btn btn-secondary btn-sm" 
              style={{ padding: '8px 16px' }}
              disabled={currentPage === 1} 
              onClick={() => setCurrentPage(prev => prev - 1)}
            >
              ◀ 上一页
            </button>
            <button 
              className="btn btn-secondary btn-sm" 
              style={{ padding: '8px 16px' }}
              disabled={currentPage >= Math.ceil(totalItems / pageSize) || totalItems === 0} 
              onClick={() => setCurrentPage(prev => prev + 1)}
            >
              下一页 ▶
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// 页面 3：Shopify 后台队列化推流
function ShopifyScraper({ currentUser, globalProxy }) {
  const [domain, setDomain] = useState('');
  const [tasks, setTasks] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalTasks, setTotalTasks] = useState(0);
  const [totalSpu, setTotalSpu] = useState(0); 
  
  const [searchDomain, setSearchDomain] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [searchKeyword, setSearchKeyword] = useState(''); 
  const [startDate, setStartDate] = useState('');         
  const [endDate, setEndDate] = useState('');             
  
  const searchRef = useRef({ domain: searchDomain, status: searchStatus, keyword: searchKeyword, start_date: startDate, end_date: endDate });
  
  const [sortOrder, setSortOrder] = useState('none');

  useEffect(() => {
    searchRef.current = { 
      domain: searchDomain, 
      status: searchStatus, 
      keyword: searchKeyword, 
      start_date: startDate, 
      end_date: endDate 
    };
    setCurrentPage(1); 
  }, [searchDomain, searchStatus, searchKeyword, startDate, endDate]);

  const [showDupImportModal, setShowDupImportModal] = useState(false);
  const [dupImportTasks, setDupImportTasks] = useState([]);
  const [pendingImportTaskIds, setPendingImportTaskIds] = useState([]);
  
  const [showImportModal, setShowImportModal] = useState(false);
  const [importTaskIds, setImportTaskIds] = useState([]);
  const [shopId, setShopId] = useState('');
  
  const [errorModalMsg, setErrorModalMsg] = useState(null);

  const fetchTasks = async (pageToFetch = currentPage, sizeToFetch = pageSize) => {
    try {
      const params = { 
        username: currentUser, 
        domain: searchRef.current.domain, 
        status: searchRef.current.status,
        keyword: searchRef.current.keyword,        
        start_date: searchRef.current.start_date,  
        end_date: searchRef.current.end_date,      
        page: pageToFetch,
        page_size: sizeToFetch
      };
      const cleanParams = Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== ''));
      const res = await axios.get('/tasks_shopify', { params: cleanParams });
      
      setTasks(res.data.data);
      setTotalTasks(res.data.total);
      setTotalSpu(res.data.total_spu);
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    fetchTasks(currentPage, pageSize);
  }, [currentUser, currentPage, pageSize]);

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1); 
  };

  const addTask = async () => {
    if (!domain) return alert("请输入目标 Shopify 域名！");
    try {
      const res = await axios.post('/check_shopify_duplicates', { domains: [domain] });
      if (res.data.duplicates.length > 0) {
        const confirmForce = window.confirm("⚠️ 该域名已经存在于采集任务库中。\n点击【确定】继续强制添加\n点击【取消】放弃操作");
        if (!confirmForce) return;
      }
      await axios.post('/add_shopify_tasks', { domains: [domain], username: currentUser });
      setDomain('');
      fetchTasks(currentPage, pageSize);
    } catch (e) { alert("添加任务失败"); }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) setSelectedTasks(tasks.map(t => t.task_id));
    else setSelectedTasks([]);
  };
  const handleSelect = (taskId) => {
    if (selectedTasks.includes(taskId)) setSelectedTasks(selectedTasks.filter(id => id !== taskId));
    else setSelectedTasks([...selectedTasks, taskId]);
  };

  const runTasks = async (taskIds) => {
    await axios.post('/run_shopify_tasks', { task_ids: taskIds, proxy: globalProxy });
    fetchTasks(currentPage, pageSize);
    setSelectedTasks([]);
  };
  
  const deleteTasks = async (taskIds) => {
    if(!window.confirm(`确定要删除 ${taskIds.length} 个任务吗？`)) return;
    await axios.post('/delete_shopify_tasks', { task_ids: taskIds });
    fetchTasks(currentPage, pageSize);
    setSelectedTasks([]);
  };

  const triggerImport = (taskIds) => {
    const selectedTaskObjects = tasks.filter(t => taskIds.includes(t.task_id));
    const alreadyImportedTasks = selectedTaskObjects.filter(t => t.status === 'imported');

    if (alreadyImportedTasks.length > 0) {
      setPendingImportTaskIds(taskIds);
      setDupImportTasks(alreadyImportedTasks);
      setShowDupImportModal(true);
    } else {
      proceedToShopIdModal(taskIds); 
    }
  };

  const proceedToShopIdModal = (filteredTaskIds) => {
    if (filteredTaskIds.length === 0) {
      alert("⚠️ 去重后没有可导入的任务！");
      setShowDupImportModal(false);
      return;
    }
    setImportTaskIds(filteredTaskIds);
    setShowDupImportModal(false);
    setShowImportModal(true);
  };

  const confirmImport = async () => {
    if(!shopId) return alert("请输入 shop_id！");
    try {
      await axios.post('/import_shopify_tasks', { task_ids: importTaskIds, shop_id: shopId, proxy: globalProxy });
      alert("🚀 任务已进入后台推送队列，系统会自动更新状态！");
      setShowImportModal(false);
      setSelectedTasks([]);
    } catch (e) { alert("接口请求异常，可能是网络断开"); }
  };

  const renderStatus = (status) => {
    switch(status) {
      case 'pending': return <span className="badge badge-neutral">⏳ 待排队</span>;
      case 'running_queue': 
      case 'running': return <span className="badge badge-warning">🔄 采集中</span>;
      case 'completed': return <span className="badge badge-success">✅ 采集完成</span>;
      case 'failed': return <span className="badge badge-danger">❌ 采集失败</span>;
      case 'importing': return <span className="badge badge-info">🚀 推送中...</span>;
      case 'imported': return <span className="badge badge-success">🎉 已导入</span>;
      case 'import_failed': return <span className="badge badge-danger">❌ 导入失败</span>;
      default: return <span className="badge badge-neutral">{status}</span>;
    }
  };

  const displayedTasks = [...tasks];
  if (sortOrder === 'desc') {
    displayedTasks.sort((a, b) => b.product_count - a.product_count);
  } else if (sortOrder === 'asc') {
    displayedTasks.sort((a, b) => a.product_count - b.product_count);
  }
  const toggleSort = () => {
    if (sortOrder === 'none') setSortOrder('desc');
    else if (sortOrder === 'desc') setSortOrder('asc');
    else setSortOrder('none');
  };

  return (
    <div>
      {showDupImportModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{ marginTop: 0, color: '#e3242b', borderBottom: '1px solid #f1f5f9', paddingBottom: '15px' }}>⚠️ 发现已导入任务</h3>
            <p style={{ color: '#475569', fontSize: '14px' }}>您选中的任务中，有 <b style={{ color: '#10b981', fontSize: '16px' }}>{dupImportTasks.length}</b> 个显示为【已导入系统】，是否继续推送？</p>
            <ul style={{ maxHeight: '200px', overflowY: 'auto', background: '#f8fafc', padding: '15px 20px 15px 35px', borderRadius: '8px', border: '1px solid #e2e8f0', color: '#334155' }}>
              {dupImportTasks.map((t, i) => <li key={i} style={{ marginBottom: '6px', fontSize: '13px' }}>{t.domain}</li>)}
            </ul>
            <div className="flex justify-between items-center" style={{ marginTop: '24px' }}>
              <button onClick={() => setShowDupImportModal(false)} className="btn btn-secondary">取消操作</button>
              <div className="flex gap-3">
                <button onClick={() => proceedToShopIdModal(pendingImportTaskIds.filter(id => !dupImportTasks.map(dt => dt.task_id).includes(id)))} className="btn btn-primary">去重后导入</button>
                <button onClick={() => proceedToShopIdModal(pendingImportTaskIds)} className="btn btn-danger">强制全部导入</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showImportModal && (
        <div className="modal-overlay">
          <div className="modal-content text-center">
            <h3 style={{ marginTop: 0, color: '#0f172a', fontWeight: 'bold' }}>🚀 全自动后台推送引擎</h3>
            <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '24px' }}>即将推送 <b>{importTaskIds.length}</b> 个任务，系统将在后台全自动消化导入。</p>
            <div style={{ textAlign: 'left', marginBottom: '8px' }}><label className="form-label">目标店铺 (Shop ID)</label></div>
            <input className="form-control" value={shopId} onChange={e => setShopId(e.target.value)} placeholder="输入数字 ID..." style={{ fontSize: '16px', marginBottom: '24px', textAlign: 'center', padding: '14px' }} />
            <div className="flex justify-center gap-4">
              <button onClick={() => setShowImportModal(false)} className="btn btn-secondary" style={{ padding: '12px 24px' }}>取消</button>
              <button onClick={confirmImport} className="btn btn-success" style={{ padding: '12px 24px' }}>确认放入推送队列</button>
            </div>
          </div>
        </div>
      )}

      {errorModalMsg !== null && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{ marginTop: 0, color: '#e3242b', borderBottom: '1px solid #f1f5f9', paddingBottom: '15px' }}>⚠️ 系统底层爬虫异常报错</h3>
            <textarea readOnly value={errorModalMsg || '无详细错误信息'} style={{ width: '100%', height: '180px', padding: '12px', border: '1px solid #e2e8f0', background: '#f8fafc', borderRadius: '8px', fontFamily: 'monospace', fontSize: '13px', resize: 'none', color: '#334155', marginTop: '10px' }} />
            <div className="flex justify-end" style={{ marginTop: '24px' }}>
              <button className="btn btn-secondary" onClick={() => setErrorModalMsg(null)}>关闭窗口</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <h3 className="card-title">✨ 新建全站产品下载任务</h3>
        <div className="flex gap-4 items-center">
          <input className="form-control" value={domain} onChange={e => setDomain(e.target.value)} placeholder="例如: www.fashionnova.com" style={{ width: '400px' }} />
          <button onClick={addTask} className="btn btn-success">➕ 新增采集任务 (待排队)</button>
        </div>
      </div>

      <div className="card">
        <div className="flex gap-3 items-center" style={{ flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 600, color: '#475569' }}>🔍 队列检索:</span>
          
          <input placeholder="搜索目标域名..." className="form-control" value={searchDomain} onChange={e => setSearchDomain(e.target.value)} style={{ width: '170px' }} />
          
          <input placeholder="搜索关键词..." className="form-control" value={searchKeyword} onChange={e => setSearchKeyword(e.target.value)} style={{ width: '140px' }} />
          
          <select className="form-control" value={searchStatus} onChange={e => setSearchStatus(e.target.value)} style={{ width: '140px' }}>
            <option value="">所有引擎状态</option>
            <option value="pending">待排队</option>
            <option value="running_queue">采集中</option>
            <option value="completed">采集完成</option>
            <option value="failed">采集失败</option>
            <option value="importing">导入中</option>
            <option value="imported">已导入</option>
            <option value="import_failed">导入失败</option>
          </select>

          <div className="flex items-center gap-1">
            <input type="date" className="form-control" value={startDate} onChange={e => setStartDate(e.target.value)} style={{ width: '130px', padding: '10px 8px' }} />
            <span style={{ color: '#94a3b8' }}>-</span>
            <input type="date" className="form-control" value={endDate} onChange={e => setEndDate(e.target.value)} style={{ width: '130px', padding: '10px 8px' }} />
          </div>

          <button onClick={() => fetchTasks(1, pageSize)} className="btn btn-primary">立即查询</button>
          {/* 👇 新增一个刷新当前页的按钮 */}
          <button onClick={() => fetchTasks(currentPage, pageSize)} className="btn btn-secondary">🔄 刷新状态</button>
          
          {searchStatus === 'completed' && (
            <div style={{ marginLeft: '12px', background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '6px 16px', borderRadius: '8px', color: '#15803d', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '12px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              <span>共筛选出 <b style={{fontSize:'16px'}}>{totalTasks}</b> 个任务</span>
              <div style={{width:'1px', height:'14px', background:'#86efac'}}></div>
              <span>总计产出数据 <b style={{fontSize:'16px'}}>{totalSpu}</b> SPU</span>
            </div>
          )}
        </div>
      </div>

      <div className="flex gap-3 mb-4 items-center">
        <button onClick={() => runTasks(selectedTasks)} disabled={selectedTasks.length === 0} className="btn btn-primary">▶️ 一键启动批量采集</button>
        <button onClick={() => triggerImport(selectedTasks)} disabled={selectedTasks.length === 0} className="btn btn-info" style={{ background: '#8b5cf6', color: 'white' }}>🚀 一键推送到独立站</button>
        <button onClick={() => deleteTasks(selectedTasks)} disabled={selectedTasks.length === 0} className="btn btn-danger">🗑️ 批量永久删除</button>
        
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px', background: 'white', padding: '4px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', boxShadow: '0 1px 2px rgba(0,0,0,0.02)' }}>
          <span style={{ fontSize: '13px', color: '#64748b', fontWeight: 600 }}>每页显示记录:</span>
          <select className="form-control" value={pageSize} onChange={handlePageSizeChange} style={{ width: '80px', padding: '4px 8px', fontSize: '13px', minHeight: 'auto' }}>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={150}>150</option>
            <option value={200}>200</option>
          </select>
        </div>
      </div>
      
      <div className="table-wrapper">
        <table className="modern-table">
          <thead>
            <tr>
              <th style={{ width: '40px', textAlign: 'center' }}><input type="checkbox" onChange={handleSelectAll} checked={selectedTasks.length === tasks.length && tasks.length > 0} style={{ cursor: 'pointer' }} /></th>
              
              {/* 🌟 修改点 3：将单一的域名列变为聚合信息列 */}
              <th>目标站点信息 (标题 / 域名 / 简介)</th>
              
              <th style={{ width: '150px' }}>搜索词来源</th>
              
              <th style={{ width: '110px', textAlign: 'center' }}>运行状态</th>
              <th 
                style={{ width: '120px', textAlign: 'center', cursor: 'pointer', userSelect: 'none' }} 
                onClick={toggleSort}
                title="点击切换排序"
              >
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                  入库数据量
                  <span style={{ fontSize: '12px', color: sortOrder !== 'none' ? '#4f46e5' : '#94a3b8' }}>
                    {sortOrder === 'desc' ? '▼' : sortOrder === 'asc' ? '▲' : '↕'}
                  </span>
                </div>
              </th>
              <th style={{ width: '160px' }}>系统提交时间</th>
              <th style={{ width: '220px', textAlign: 'center' }}>操作区</th>
            </tr>
          </thead>
          <tbody>
            {displayedTasks.map(task => (
              <tr key={task.task_id}>
                <td style={{ textAlign: 'center' }}><input type="checkbox" checked={selectedTasks.includes(task.task_id)} onChange={() => handleSelect(task.task_id)} style={{ cursor: 'pointer' }} /></td>
                
                {/* 🌟 修改点 4：美化展示 Title, Domain, Snippet */}
                <td>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxWidth: '400px' }}>
                    <div style={{ fontWeight: 600, color: '#0f172a', fontSize: '15px' }} title={task.title}>{task.title || '未知标题 / 手动添加'}</div>
                    <span style={{ color: '#4f46e5', fontSize: '13px', fontWeight: 500 }}>{task.domain}</span>
                    <div style={{ color: '#64748b', fontSize: '13px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.5' }} title={task.snippet}>
                      {task.snippet || '暂无简介数据'}
                    </div>
                  </div>
                </td>
                
                <td>
                  <span style={{ color: '#64748b', fontSize: '13px' }}>
                    {task.keyword ? task.keyword.replace(/site:myshopify\.com/gi, '').trim() : '手动添加/未记录'}
                  </span>
                </td>
                
                <td style={{ textAlign: 'center' }}>{renderStatus(task.status)}</td>
                <td style={{ textAlign: 'center' }}><b style={{ fontSize: '15px', color: '#4338ca' }}>{task.product_count}</b> <span style={{ color: '#94a3b8', fontSize: '12px' }}>SPU</span></td>
                <td style={{ color: '#64748b', fontSize: '13px' }}>{new Date(task.timestamp).toLocaleString()}</td>
                <td>
                  <div className="flex justify-center gap-2">
                    <button onClick={() => runTasks([task.task_id])} className="btn btn-primary btn-sm">重采</button>
                    <button onClick={() => triggerImport([task.task_id])} className="btn btn-sm" style={{ background: '#8b5cf6', color: 'white', border: 'none' }}>导入</button>
                    <button onClick={() => deleteTasks([task.task_id])} className="btn btn-danger btn-sm">删除</button>
                    {task.error_msg && task.error_msg.trim() !== '' && (
                      <button onClick={() => setErrorModalMsg(task.error_msg)} className="btn btn-secondary btn-sm" style={{ background: '#cbd5e1' }}>日志</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            {tasks.length === 0 && <tr><td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: '#94a3b8' }}>暂无采集任务数据</td></tr>}
          </tbody>
        </table>
      </div>

      {totalTasks > 0 && (
        <div className="flex justify-between items-center" style={{ marginTop: '20px', background: 'white', padding: '12px 24px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <span style={{ fontSize: '14px', color: '#64748b' }}>
            共 <b style={{ color: '#0f172a', fontSize: '16px' }}>{totalTasks}</b> 个任务，当前第 <b style={{ color: '#4f46e5', fontSize: '16px' }}>{currentPage}</b> / {Math.ceil(totalTasks / pageSize)} 页
          </span>
          <div className="flex gap-2">
            <button 
              className="btn btn-secondary btn-sm" 
              style={{ padding: '8px 16px' }}
              disabled={currentPage === 1} 
              onClick={() => setCurrentPage(prev => prev - 1)}
            >
              ◀ 上一页
            </button>
            <button 
              className="btn btn-secondary btn-sm" 
              style={{ padding: '8px 16px' }}
              disabled={currentPage >= Math.ceil(totalTasks / pageSize) || totalTasks === 0} 
              onClick={() => setCurrentPage(prev => prev + 1)}
            >
              下一页 ▶
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// 🌟 主布局组件
function App() {
  const [currentUser, setCurrentUser] = useState(localStorage.getItem('sysUser') || '');
  const [proxyEnabled, setProxyEnabled] = useState(localStorage.getItem('sysProxyEnabled') === 'true');
  
  const defaultProxyConfig = { type: 'socks5h', host: '', port: '', username: '', password: '' };
  const storedProxyConfig = localStorage.getItem('sysProxyConfig');
  const [proxyConfig, setProxyConfig] = useState(storedProxyConfig ? JSON.parse(storedProxyConfig) : defaultProxyConfig);
  
  const [showProxyModal, setShowProxyModal] = useState(false);
  const [tempConfig, setTempConfig] = useState(proxyConfig); 
  const [testResult, setTestResult] = useState('');
  const [isTesting, setIsTesting] = useState(false);

  if (!currentUser) {
    return (
      <BrowserRouter>
        <ModernStyles />
        <Login onLogin={setCurrentUser} />
      </BrowserRouter>
    );
  }

  const buildProxyString = (config) => {
    if (!config.host || !config.port) return '';
    let auth = '';
    if (config.username && config.password) auth = `${config.username.trim()}:${config.password.trim()}@`;
    else if (config.username) auth = `${config.username.trim()}@`;
    return `${config.type}://${auth}${config.host.trim()}:${config.port.trim()}`;
  };

  const finalProxyString = proxyEnabled ? buildProxyString(proxyConfig) : '';

  const handleOpenProxyModal = () => { setTempConfig(proxyConfig); setTestResult(''); setShowProxyModal(true); };
  const handleSaveProxy = () => { setProxyConfig(tempConfig); localStorage.setItem('sysProxyConfig', JSON.stringify(tempConfig)); setShowProxyModal(false); };

  const handleTestProxy = async () => {
    const proxyStr = buildProxyString(tempConfig);
    if (!proxyStr) { setTestResult("⚠️ 格式不完整：请至少填写【代理域名/IP】和【端口】！"); return; }
    setIsTesting(true);
    setTestResult("⏳ 正在请求核心节点连通性测试...\n请耐心等待，最长需 15 秒...");
    try {
      const res = await axios.post('/test_proxy', { proxy: proxyStr });
      if (res.data.status === 'success') setTestResult(`✅ 测试成功！底层网络链路通畅！\n\n[目标服务器识别出的您的出境原生IP]\n${res.data.msg}`);
      else setTestResult(`❌ 测试失败！\n\n[底层异常日志 / 墙拦截反馈]\n${res.data.msg}`);
    } catch (e) { setTestResult(`❌ 系统灾难性错误：无法连接到本地 Python 核心引擎服务。`); }
    setIsTesting(false);
  };

  return (
    <BrowserRouter>
      <ModernStyles />
      
      {showProxyModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '600px' }}>
            <h3 style={{ marginTop: 0, color: '#0f172a', borderBottom: '1px solid #e2e8f0', paddingBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>⚙️</span> 全局底层链路代理配置
            </h3>
            
            <div className="form-group">
              <label className="form-label">传输加密协议 (Protocol)</label>
              <select className="form-control" value={tempConfig.type} onChange={e => setTempConfig({...tempConfig, type: e.target.value})} style={{ marginBottom: '16px' }}>
                <option value="http">HTTP (基础网页代理)</option>
                <option value="https">HTTPS (TLS 加密代理)</option>
                <option value="socks4">SOCKS4 (底层协议)</option>
                <option value="socks5">SOCKS5 (推荐 - 常规)</option>
                <option value="socks5h">SOCKS5h (推荐 - 远程DNS防泄漏防封)</option>
              </select>
            </div>

            <div className="flex gap-4 form-group" style={{ marginBottom: '16px' }}>
              <div style={{ flex: 3 }}>
                <label className="form-label">代理域名节点 / IP (Host)</label>
                <input className="form-control" value={tempConfig.host} onChange={e => setTempConfig({...tempConfig, host: e.target.value})} placeholder="如: node01.proxy-cheap.com" />
              </div>
              <div style={{ flex: 1 }}>
                <label className="form-label">端口 (Port)</label>
                <input className="form-control" value={tempConfig.port} onChange={e => setTempConfig({...tempConfig, port: e.target.value})} placeholder="如: 8080" />
              </div>
            </div>

            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label className="form-label">认证账号 (Username) - 纯净IP可留空</label>
              <input className="form-control" value={tempConfig.username} onChange={e => setTempConfig({...tempConfig, username: e.target.value})} placeholder="输入代理平台分配的用户名" />
            </div>

            <div className="form-group" style={{ marginBottom: '24px' }}>
              <label className="form-label">认证密钥 (Password) - 纯净IP可留空</label>
              <input className="form-control" value={tempConfig.password} onChange={e => setTempConfig({...tempConfig, password: e.target.value})} placeholder="输入代理平台分配的密码" />
            </div>

            <div style={{ background: '#f8fafc', padding: '16px', borderRadius: '12px', marginBottom: '24px', border: '1px solid #e2e8f0' }}>
              <button onClick={handleTestProxy} disabled={isTesting} className="btn btn-info" style={{ width: '100%', marginBottom: '12px', background: isTesting ? '#cbd5e1' : '#6366f1', color: 'white' }}>
                {isTesting ? '正在发送测试请求，请稍候...' : '🔌 一键诊断当前链路连通性'}
              </button>
              {testResult && (
                <textarea readOnly value={testResult} style={{ width: '100%', height: '120px', padding: '12px', background: '#0f172a', color: '#10b981', border: 'none', borderRadius: '8px', fontSize: '13px', fontFamily: 'monospace', resize: 'vertical' }} />
              )}
            </div>

            <div className="flex justify-end gap-3" style={{ paddingTop: '16px', borderTop: '1px solid #e2e8f0' }}>
              <button onClick={() => setShowProxyModal(false)} className="btn btn-secondary">取消更改</button>
              <button onClick={handleSaveProxy} className="btn btn-primary">保存生效配置</button>
            </div>
          </div>
        </div>
      )}

      {/* 顶部现代化导航栏 */}
      <nav className="navbar">
        <div className="flex items-center gap-4">
          <div style={{ background: 'linear-gradient(135deg, #6366f1, #4f46e5)', padding: '6px', borderRadius: '8px', display: 'flex' }}>
            <span style={{ color: 'white', fontSize: '18px' }}>🚀</span>
          </div>
          <h1 style={{ fontSize: '18px', margin: 0, color: '#0f172a', fontWeight: 'bold', letterSpacing: '0.02em', marginRight: '24px' }}>微媒采集引擎</h1>
          
          <div className="nav-links">
            <NavLink to="/search" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>1. 找站采集 (Serper)</NavLink>
            <NavLink to="/dashboard" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>2. 全局站库</NavLink>
            <NavLink to="/shopify" className={({isActive}) => isActive ? 'nav-item active' : 'nav-item'}>3. Shopify API 队列与推流</NavLink>
          </div>
        </div>
        
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2" style={{ background: proxyEnabled ? '#f0fdf4' : '#f8fafc', padding: '4px 12px 4px 8px', borderRadius: '99px', border: `1px solid ${proxyEnabled ? '#bbf7d0' : '#e2e8f0'}` }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0, fontSize: '13px' }}>
              <input type="checkbox" checked={proxyEnabled} onChange={e => { setProxyEnabled(e.target.checked); localStorage.setItem('sysProxyEnabled', e.target.checked); }} style={{ margin: '0 8px 0 4px', cursor: 'pointer' }} />
              <span style={{ fontWeight: 600, color: proxyEnabled ? '#15803d' : '#64748b' }}>全局防封代理: {proxyEnabled ? '开启' : '关闭'}</span>
            </label>
            <div style={{ width: '1px', height: '16px', background: proxyEnabled ? '#bbf7d0' : '#e2e8f0', margin: '0 4px' }}></div>
            <button onClick={handleOpenProxyModal} className="btn" style={{ background: 'none', color: '#4f46e5', padding: '2px 6px', fontSize: '13px' }}>配置</button>
          </div>
          
          <div style={{ width: '1px', height: '24px', background: '#e2e8f0', marginLeft: '8px', marginRight: '8px' }}></div>
          
          <div className="flex items-center gap-3">
            <div style={{ background: '#e0e7ff', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: '#4338ca', fontSize: '14px' }}>
              {currentUser.substring(0, 2).toUpperCase()}
            </div>
            <span style={{ fontSize: '14px', color: '#475569', fontWeight: 500 }}>当前账户: <b style={{color: '#0f172a'}}>{currentUser}</b></span>
            <button onClick={() => {localStorage.removeItem('sysUser'); setCurrentUser('');}} className="btn btn-secondary btn-sm" style={{ color: '#ef4444', border: 'none', background: '#fee2e2' }}>安全退出</button>
          </div>
        </div>
      </nav>
      
      <div className="main-container">
        <Routes>
          <Route path="/search" element={<UrlSearch currentUser={currentUser} globalProxy={finalProxyString} />} />
          <Route path="/dashboard" element={<GlobalDashboard currentUser={currentUser} />} />
          <Route path="/shopify" element={<ShopifyScraper currentUser={currentUser} globalProxy={finalProxyString} />} />
          <Route path="*" element={<Navigate to="/search" />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;